import {computed} from "vue";
import store from "@/store";

export function useOrdenacao() {
  const ORDER_BY_COMPUTED = computed({
    get: () => store.getters["diagnosticoAnaliseQualitativaEstoque/orderBy"],
    set: valor => store.dispatch("diagnosticoAnaliseQualitativaEstoque/orderBy", valor),
  });

  const ORDER_BY_OBJECT_COMPUTED = computed(() => {
    const [coluna, ordem] = ORDER_BY_COMPUTED.value;
    return { coluna, ordem };
  })

  function ordenarColuna(ev) {
    const [coluna, ordem] = ORDER_BY_COMPUTED.value;
    if (coluna === ev.value && ordem === ev.order) return;
    ORDER_BY_COMPUTED.value = [ev.value, ev.order];
  }

  return {
    ORDER_BY_COMPUTED,
    ORDER_BY_OBJECT_COMPUTED,
    ordenarColuna
  }
}
